


































































































import Vue from 'vue';
import BoxContainer from "@/components/BoxContainer.vue";
import {AmendmentViewModel} from "../../models/AmendmentViewModel";

export default Vue.extend( {
  name: "AmendmentDetailsPanel" ,
  components: {
    BoxContainer
  },
  props: {
    amendment: {
      type: Object as () => AmendmentViewModel ,
    }
  },
  data(): {

  }{
    return {

    }
  },
  methods: {},
  mounted: async function() {
    // DO SOMETHING
  }
})

